// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#chat-container[data-v-6d31bb9e]{width:300px;height:400px;border:1px solid #fff;background-color:#fff}.close-button[data-v-6d31bb9e]{position:absolute;top:10px;right:10px;background-color:red;color:#fff;border:none;border-radius:50%;width:25px;height:25px;cursor:pointer;font-size:16px;line-height:25px;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
